<template>
    <div>
        <div class="resource-selector row">
            <div class="col">
                <input type="hidden" :name="formFieldName" :value="selectedFormValue">

                <multiselect
                            v-model="selectedCountry"
                            :options="options"
                            @select="select"
                            :placeholder="placeholder"
                            :loading="isLoading"
                            label="label"
                            track-by="label">
                    <template slot="singleLabel" slot-scope="{ option }">
                        <span class="option__desc">
                            <span class="option__title">{{ option.label }}</span>
                        </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <div class="option__desc">
                            <span class="option__title">{{ option.label }}</span>
                        </div>
                    </template>
                    <template slot="noResult">
                        {{ $t('No results found') }}
                    </template>
                    <template slot="noOptions">
                        {{ $t('Start searching by typing') }}
                    </template>
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

const countriesList = require('i18n-iso-countries')
countriesList.registerLocale(require('i18n-iso-countries/langs/en.json'))

export default {
    components: {Multiselect},
    name: "CountryCodeSelector",

    props: {
        placeholder: {
            default: 'Search country...'
        },
        formFieldName: {
            default: 'country'
        },
        prefilledCountryCode: {
            default: null
        }
    },

    mounted() {
        this.options = this.countries;

        if (this.prefilledCountryCode !== null && this.prefilledCountryCode !== '') {
            this.selectedCountry = this.options.find(x => x.value === this.prefilledCountryCode);
        }
    },

    data: () => {
        return {
            options: [],
            selectedCountry: null,
            isLoading: false,
        }
    },

    methods: {
        select(value) {
            this.selectedCountry = value;
            this.$emit('country-selected', this.selectedCountry.value)
        },

        remove(value) {
            this.selectedCountry = null;
        }
    },

    computed: {
        countries() {
            const list = countriesList.getNames('en', {select: 'official'})
            return Object.keys(list).map((key) => ({value: key, label: list[key]}))
        },
        selectedFormValue() {
            return this.selectedCountry?.value;
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
